<template>
  <div class="summary">
    <div class="wrapper">
      <price-range :name="carName" :lead="lead"></price-range>
      <TypeFormRedirect :token="lead.token" />
      <InfoChart style="margin-bottom:40px;" />
      <feedback :lead="lead"></feedback>
      <section class="summary-section" style="background:#f6f7fb;">
        <h3 class="summary-section-title">Nimm die Preisbewertung mit zum Händler!</h3>
        <p class="summary-section-text">
          Die TÜV-geprüfte Preisbewertung ist eine gute Verhandlungsgrundlage beim Händler.
        </p>
        <a class="summary-section-btn ct-print" onclick="window.print();">Fahrzeugbewertung ausdrucken</a>
      </section>
      <section class="summary-section">
        <h3 class="summary-section-title">Finde noch heute dein Traumauto!</h3>
        <p class="summary-section-text">
          Neu- und Gebrauchtwagen mit Preis-Check direkt vom Händler.
        </p>
        <a href="http://suche.pkw.de/fahrzeuge" class="summary-section-btn ct-search">Autosuche starten</a>
      </section>
      <section class="summary-section" style="border-top: 1px solid #d8d8d8;border-radius:0">
        <h3 class="summary-section-title">Autohändler gesucht?</h3>
        <p class="summary-section-text">
          Auf PKW.de findest du den passenden Händler in deiner Nähe.
        </p>
        <a href="https://pkw.de/autohaus" class="summary-section-btn ct-cms">
          Alle Städte ansehen
        </a>
        <div class="summary-section-list-wrapper">
          <ul class="summary-section-list">
          <li>
            <a href="https://pkw.de/autohaus/berlin">Berlin</a>
          </li>
          <li>
            <a href="https://www.pkw.de/autohaus/duesseldorf">Düsseldorf</a>
          </li>
          <li>
            <a href="https://pkw.de/autohaus/wuppertal">Wuppertal</a>
          </li>
          <li>
            <a href="https://www.pkw.de/autohaus/muenchen">München</a>
          </li>
          <li>
            <a href="https://pkw.de/autohaus/hamburg">Hamburg</a>
          </li>
          <li>
            <a href="https://www.pkw.de/autohaus/dortmund">Dortmund</a>
          </li>
          <li>
            <a href="https://www.pkw.de/autohaus/frankfurt-am-main">Frankfurt</a>
          </li>
          <li>
            <a href="https://www.pkw.de/autohaus/nuernberg">Nürnberg</a>
          </li>
        </ul>
        </div>
      </section>
    </div>
    <div class="wrapper-print">
      <pricepreview :name="carName"></pricepreview>
      <template v-if="selection">
        <div class="wrapper-print-record">
          <strong>Marke</strong>
          <span>{{selection.make}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Modell</strong>
          <span>{{selection.model}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Erstzulassung</strong>
          <span>{{selection.month}} / {{selection.year}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Fahrzeugtyp</strong>
          <span>{{selection.bodytype}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Kraftstoff</strong>
          <span>{{selection.fuel}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Leistung</strong>
          <span>{{selection.power}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Motor</strong>
          <span>{{selection.engine}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Variante</strong>
          <span>{{selection.equipment}}</span>
        </div>
        <div class="wrapper-print-record">
          <strong>Kilometerstand</strong>
          <span>{{selection.mileage}} km</span>
        </div>
        <div class="wrapper-print-record" v-if="selection.extras">
          <strong>Extras</strong>
          <span>{{selection.extras}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Pricegraph from './summary/SummaryPricegraph'
import Mobile from './summary/SummaryMobile.vue'
import Pricepreview from './summary/SummaryPricepreview.vue'
import PriceRange from './summary/SummaryPriceRange'
import Feedback from './summary/SummaryFeedback'
import InfoChart from './InfoChart'
import TypeFormRedirect from './TypeFormRedirect'

import { Api } from '../services/api'
import { currentPath } from '../services/helpers'

export default {
  components: {
    Pricegraph,
    Pricepreview,
    Mobile,
    PriceRange,
    Feedback,
    InfoChart,
    TypeFormRedirect,
    TypeFormRedirect
  },
  data: function() {
    let selection = null;

    try {
        selection = JSON.parse(localStorage.getItem('pkw_selected'));
    } catch (e) {}

    return { selection };
  },
  mounted() {
    Api.get(this.$store, "getLead");
  },
  methods: {
    doRedirect: function() {
      this.$store.dispatch('redirect')
    }
  },
  computed: {
    lead: function() { return (this.$store.state.lead || {}) },
    carName: function() {
      return this.lead['car_name']
    },
    isVwoTracking: function () { return false },
    price: function() { this.lead['mobile_purchase_price'] },
    isPurchasePrice: function() {
      return !this.price
    },
    submitButtonText: function() {
      return this.isPurchasePrice
        ? 'Bewertung auf mobile.de abschließen'
        : 'Jetzt Preise von Händlern auf mobile.de erhalten'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/vars";

  .summary {
    text-align: center;
    border-top: 1px solid #eee;
    background-color: #f6f7fb;
    padding-bottom: 50px;

    &.disabled {
      opacity: 0.4;
    }

    header {
      height: 60px;
      line-height: 60px;
      text-align: center;
      box-shadow: 0 1px 3px 0 rgba(0,0,0,0.24);
      background-color: white;

      @media (max-width: 500px) {
        box-shadow: none;
      }

      img {
        width: 111px;
        margin-top: 10px;
      }
    }

    h2 {
      text-align: center;
      font-size: 38px;
      line-height: 44px;
      text-transform: uppercase;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .wrapper-print {
      display: none;
    }

    .wrapper {
      padding: 54px 60px 0!important;
      width: 1125px !important;
      margin: 54px auto 0 !important;
      background-color: white;
      box-shadow: 0 0 25px rgba(0, 0, 0, 0.05);
      border-radius: 4px;

      @media (max-width: 1000px) {
        width: 95.23178808% !important;
      }

      @media (max-width: 900px) {
        padding: 36px 0 0!important;
      }

      @media (max-width: 500px) {
        width: 100% !important;
        margin: 0 auto !important;
        box-shadow: none !important;
      }
    }

    .wrapper-print-record {
      display: flex;
      padding: 12px 0;
      font-size: 15px;
      text-align: left;

      &:not(:last-child) {
        border-bottom: 1px solid $border-color;
      }

      strong {
        min-width: 120px;
      }

      span {
        padding-left: 30px;
      }
    }

    @media print {
      border: 0;
      padding: 90px;
      background-color: white;

      .wrapper { display: none; }
      .wrapper-print { display: block; }

      header {
        text-align: left;
        border: 0;
        box-shadow: none;
      }
    }
  }

  .summary-section {
    padding: 45px 0 55px;
    border-radius: 20px;
    @media (max-width: 900px) {
      border-radius: 0;
    }
  }

  .summary-section-title {
    color: #010101;
    margin: 0 0 5px;
    font-family: "Asap", sans-serif;
    font-size: 28px;
    font-weight: 700;
  }

  .summary-section-text {
    color: #010101;
    max-width: 560px;
    padding: 0 10px;
    margin: 0 auto 60px;
    font-size: 16px;
    line-height: 22px;
  }

  .summary-section-btn {
    display: inline-block;
    line-height: 41px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    height: 42px;
    border-radius: 25px;
    font-family: "Asap", sans-serif;

    &.ct-print {
      color:#c4232a;
      padding: 0 40px;
      border: 1px solid #c4232a;
      background-color: #ffffff;
      height: 50px;
      line-height: 48px;
      &:hover {
        background-color: rgba(196, 35, 42, 0.06)
      }
    }

    &.ct-search {
      height: 50px;
      line-height: 48px;
      padding: 0 55px;
      background-color: #c4232a;
      border: 1px solid #c4232a;
      &:hover {
        background-color: rgba(196, 35, 42, 0.9)
      }
    }

    &.ct-cms {
      color:#c4232a;
      padding: 0 40px;
      border: 1px solid #c4232a;
      background-color: #ffffff;
      margin-bottom: 40px;
      &:hover {
        background-color: rgba(196, 35, 42, 0.06)
      }
    }
  }

  .summary-section-list-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  .summary-section-list {
    position: relative;
    right: -25px;
    display: flex;
    flex-wrap: wrap;
    max-width: 660px;
    padding: 12px 0 0;

    @media (max-width: 750px) {
      max-width: 400px;
      justify-content: center;
    }

    @media (max-width: 450px) {
      max-width: 250px;
    }

    & > li {
      position: relative;
      width: 165px;
      font-size: 14px;
      text-align: left;
      list-style: none;
      padding-left: 25px;
      padding-bottom: 12px;

      &::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 8px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #c4232a;
      }

      & > a {
        font-weight: lighter;
        text-decoration: none;
        color: $dark-gray-variant;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .summary-links {
    display: flex;
    padding: 30px 0;
    list-style: none;
    margin: 0;
    text-align: center;
    justify-content: center;

    & > li:not(:last-child) {
      padding-right: 30px;
    }

    & > li > a {
      text-decoration: none;
      color: #b5b5b5;
      font-size: 14px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Summary.vue